import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormTitle from '../../../library/form/components/FormTitle'
import FormSearchButton from '../../../library/form/components/FormSearchButton';
import FormImportLink from '../../../library/form/components/FormImportLink';
import FormPaging from '../../../library/form/components/FormPaging'
import FormLauncher from '../../cmn/docAutomation/FormLauncher'
import FormButton from '../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiAction } from "../../../library/layout/Index";

const InvItemDetails = (props) => {
    const { formObject, viewData } = props;
    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Line Item' />
                </UiTitle>
                <UiAction>
                    <div className='uiFlexBox3'>
                        <FormPaging formObject={formObject} />

                        <FormSearchButton autofocus formObject={formObject} rowKey="" headerKey='lineItemLink'
                            action={{ actionId: "refresh", actionParam: {} }}
                            className='uiActionIconButton' placeholder="Barcode or Item Id"
                        />

                        <FormButton formObject={formObject} ksc="h" rowKey="" headerKey='headerRows'
                            action={{ actionId: "refresh", paramName: "importPending", actionParam: {"importPending":1, "imdtId":"%dataList.imdtId"} }}
                            className="uiActionIconButton" text={<SarasTrans value="Add Pending SO" />}></FormButton>

                        <FormImportLink className="uiActionIconButton" formObject={formObject} rowKey="" headerKey='importLink' action={{}} />
                    </div>
                </UiAction>
            </UiViewHeading>
            <div className="listItemDetails phViewContentContainer">
                {
                    Object.values(viewData).map((row, index) => (
                        <FormLauncher viewMap={formObject.viewMap} formObject={formObject} 
                            pushFormObject={1}
                            compositionKey={row.rowKey} viewData={row} rowKey={row.rowKey} ></FormLauncher>     
                    ))
                }
            </div>
        </UiView>
    )
}

export default withView(InvItemDetails, "itemDetail", "itemDetail,invTrnHeader,invTrnFooter,invTrans,ccbreakup,invTrnTracker")